import React, { useContext } from "react";

import { Typography } from "@mui/material";
import clsx from "clsx";
import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { getCurrencyCodeByLocale } from "~/constants/i18n";
import { DictionaryLabelContext } from "~/context/dictionary-label/context";
import { DictionaryKeys } from "~/context/dictionary-label/types";
import { getDisplayPrice } from "~/helpers/get-display-price";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { PRICE_PANEL_CLASSES } from "./constants";
import { PricePanelContainer } from "./styled";
import { PricePanelProps } from "./types";

export const PricePanel = ({ price }: PricePanelProps) => {
  const { locale } = useParams<GlobalPathParams>();
  const currencyCode = getCurrencyCodeByLocale(locale);

  const dictionary = useContext(DictionaryLabelContext);

  const fromLabel = dictionary?.[DictionaryKeys.FromLabel];

  const isClearance =
    Boolean(price?.clearance) && price?.clearance !== price?.regular;

  const regularPrice = getDisplayPrice(locale, currencyCode, price?.regular, true);
  const clearancePrice = getDisplayPrice(
    locale,
    currencyCode,
    price?.clearance,
    true,
  );

  return (
    <PricePanelContainer>
      <Typography
        {...getTestAutomationProps("product-price")}
        className={clsx(PRICE_PANEL_CLASSES.currentPrice, {
          [PRICE_PANEL_CLASSES.clearancePrice]: isClearance,
        })}
      >
        {price?.isRange ? fromLabel : ""}{" "}
        {isClearance ? clearancePrice : regularPrice}
      </Typography>
      {isClearance && (
        <Typography
          {...getTestAutomationProps("old-price")}
          className={PRICE_PANEL_CLASSES.previousPrice}
        >
          {regularPrice}
        </Typography>
      )}
    </PricePanelContainer>
  );
};
